/* eslint-disable */
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  currentKwVolumeAmazonCategoryList,
  fetchKwVolumePickerOptions,
  kwVolAmazonCategoryTreeSelector,
  kwVolumePickerOptionsSelector,
  kwVolumePickerOptionsStatusSelector
} from 'feactures/categoryKeywordVolume/categoryKeywordVolumeSlice';

/**
 * 検索ボリューム登録モーダル用: SC マスタの picker_options と子階層ツリーを扱う。
 */
export function useKwVolumeCategoryPicker({ open, accountId, enabled }) {
  const dispatch = useDispatch();
  const selectedPath = useSelector(currentKwVolumeAmazonCategoryList);
  const pickerTree = useSelector(kwVolAmazonCategoryTreeSelector);
  const pickerOptions = useSelector(kwVolumePickerOptionsSelector);
  const pickerStatus = useSelector(kwVolumePickerOptionsStatusSelector);

  useEffect(() => {
    if (!open || !accountId || !enabled) return;
    dispatch(
      fetchKwVolumePickerOptions({ marketplace: 'JP', account_id: accountId })
    );
  }, [open, accountId, enabled, dispatch]);

  const pickerLoading =
    enabled &&
    (pickerStatus === 'loading' ||
      pickerStatus === 'idle' ||
      (pickerStatus === 'succeeded' &&
        !pickerOptions?.master_unavailable &&
        (!Array.isArray(pickerTree?.category1) ||
          pickerTree.category1.length === 0)));

  const grayscaleIds = pickerOptions?.grayscale_ids;

  const grayscaleSet = useMemo(() => {
    if (
      !enabled ||
      pickerStatus !== 'succeeded' ||
      !pickerOptions ||
      pickerOptions.master_unavailable ||
      !Array.isArray(grayscaleIds)
    ) {
      return null;
    }
    return new Set(grayscaleIds.map((x) => Number(x)));
  }, [grayscaleIds, pickerOptions, pickerStatus, enabled]);

  const registerTargetIsGrayscale = useMemo(() => {
    if (!grayscaleSet) return false;
    const path = (selectedPath || []).filter((x) => x && x.value);
    if (!path.length) return false;
    const last = path[path.length - 1];
    return grayscaleSet.has(Number(last.value));
  }, [selectedPath, grayscaleSet]);

  const comboGrayscaleIds =
    enabled &&
    pickerStatus === 'succeeded' &&
    pickerOptions &&
    !pickerOptions.master_unavailable
      ? grayscaleIds
      : undefined;

  return {
    pickerTree,
    pickerLoading,
    navStatus: pickerStatus,
    navRootFallback: false,
    comboGrayscaleIds,
    pickerTrackedCategories: pickerOptions?.tracked_categories || [],
    registerTargetIsGrayscale,
    pickerMasterUnavailable:
      pickerStatus === 'succeeded' && Boolean(pickerOptions?.master_unavailable)
  };
}
